import http from '@/utils/http'
import {getSign, getToken} from '@/utils/auth'

export function fetchList(query) { 
  query.sign = getSign(query, getToken());
  return http({
    url: '/api/device/brand',
    method: 'get',
    params: query
  })
} 



// WEBPACK FOOTER //
// ./src/api/base/devicebrand.js